import React from 'react';
import ComingSoon from '../../components/ComingSoon';

export default function FinancialReports() {
    return <ComingSoon moduleName="Financial Reports" description="Export data formatted for Zoho Books and analyze profitability." estimatedPhase="Phase 6 (Weeks 14-15)" priority="MEDIUM" />;
}
